import { createContext, useContext, type Dispatch, type SetStateAction } from "react";

import type { ActiveWidget } from "../hooks/useEventWidgets";

type EventWidgetsContext = [ActiveWidget[] | null, Dispatch<SetStateAction<ActiveWidget[] | null>>];

export const EventWidgetsContext = createContext<EventWidgetsContext>(null!);

export function useEventWidgetsContext(): EventWidgetsContext {
  return useContext(EventWidgetsContext);
}
